import React, { useState } from 'react';
import { CheckCircle2, XCircle, MinusCircle, CircleDashed, ChevronDown } from 'lucide-react';

const STATUS = {
  correct: { icon: CheckCircle2, cls: 'text-emerald-600', label: 'Correct' },
  partial: { icon: MinusCircle, cls: 'text-amber-600', label: 'Partial' },
  incorrect: { icon: XCircle, cls: 'text-red-600', label: 'Incorrect' },
  unanswered: { icon: CircleDashed, cls: 'text-slate-400', label: 'Not attempted' },
};
const KIND = { mcq: 'Scenario', scalar: 'Formula', column: 'Fill-down', spill: 'Dynamic array', cf: 'Cond. format', dv: 'Validation' };

const ItemRow = ({ item, n }) => {
  const [open, setOpen] = useState(false);
  const st = STATUS[item.status] || STATUS.incorrect;
  const Icon = st.icon;
  const ans = item.candidate_answer || {};
  return (
    <div className="border-b border-slate-100 last:border-0" data-testid={`report-item-${item.id}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 py-3 text-left hover:bg-slate-50/70 px-2 rounded-lg transition-colors">
        <Icon className={`h-5 w-5 shrink-0 ${st.cls}`} />
        <span className="text-xs font-mono text-slate-400 w-6">{n}</span>
        <span className="flex-1 min-w-0">
          <span className="block text-sm text-slate-800 truncate">{item.prompt}</span>
          <span className="block text-[11px] text-slate-500">{item.skill_short} · {KIND[item.kind]}{item.difficulty !== 'scenario' ? ` · ${item.difficulty}` : ''}</span>
        </span>
        <span className="text-sm font-bold text-slate-900 w-12 text-right">{item.score}%</span>
        <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="pl-14 pr-4 pb-4 space-y-2 text-sm">
          {ans.formula && <p><span className="text-slate-500">Candidate formula: </span><code className="text-xs bg-slate-100 text-indigo-700 px-1.5 py-0.5 rounded break-all">{ans.formula}</code></p>}
          {ans.value && <p><span className="text-slate-500">{item.kind === 'mcq' ? 'Answered: ' : 'Result: '}</span><span className="text-slate-800">{ans.value}</span></p>}
          {item.kind === 'mcq' && <p><span className="text-slate-500">Correct answer: </span><span className="text-emerald-700">{item.expected}</span></p>}
          {item.model && item.kind !== 'mcq' && <p><span className="text-slate-500">Model answer: </span><code className="text-xs bg-emerald-50 text-emerald-800 px-1.5 py-0.5 rounded break-all">{item.model}</code></p>}
          <p className="text-slate-600 bg-slate-50 border border-slate-100 rounded-lg px-3 py-2">{item.feedback}</p>
        </div>
      )}
    </div>
  );
};

export const ItemBreakdown = ({ items }) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="report-item-breakdown">
    <h3 className="text-lg font-bold text-slate-900 mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>Task-by-task evaluation</h3>
    <div>{items.map((it, i) => <ItemRow key={it.id} item={it} n={i + 1} />)}</div>
  </section>
);

export default ItemBreakdown;
